module.exports = __webpack_public_path__ + "media/accessories/adjustable_smt_stencil_fixture-8db53b00.png";